import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Messages from "../../lang/fa/messages";
import { apiSetAlert } from "../../api/appApi";
import { FormTypeSelectionInput } from "../Input";
import {
    addForm,
    deleteIndex,
    resetForm,
    setAction,
    setDeleteQueue,
    setIndex,
    undoDeleteQueue,
} from "../../store/actions/formAction";

import ArrowBackList from "../../assets/svg/arrow-back-list.svg";
import AddNewListIcon from "../../assets/svg/add-row.svg";
import iconLoading from "../../assets/svg/icon-loading.svg";
import IconEditHover from "../../assets/svg/pen-icon-account.svg";
import IconDelete from "../../assets/svg/icon-delete-show-account.svg";
import arrowLeftFactorBlue from "../../assets/svg/arrow-left-factorBlue.svg";
import deleteWarningItem from "../../assets/svg/delete-warning-item.svg";
import IconSaved from "../../assets/svg/icon-saved.svg";
import "../../assets/styles/productServices/addProduct.scss";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useNavigate } from "react-router-dom";
import { RenderFormInputs, RenderInput } from "../Input/render";
import { appSetBackUrl } from "../../store/actions/appAction";

export const PageHeader = ({ header, activeTab, spaceLess = false }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const backUrl = useSelector((state) => state).appReducer.backUrl;

    const funcBackUrl = (e) => {
        let url = header.backUrl;
        if (backUrl) {
            url = backUrl;
            dispatch(appSetBackUrl(null));
        }
        navigate(url, {
            state: {
                type: activeTab,
            },
        });
        e.preventDefault();
    };

    return (
        <div
            className="flex fle-row justify-between items-center mt-2 "
            style={spaceLess ? { marginRight: "-25px", paddingRight: 25 } : null}
        >
            <div className="right-title-product">
                <div className="text-xl font-IRANSansMedium">{header.title}</div>
                <div className="text-sm font-IRANSans mt-1">{header.description}</div>
            </div>
            {header.backTitle ? (
                <a className="flex flex-row text-gray-400" href={header.backUrl} onClick={(e) => funcBackUrl(e)}>
                    <img className="img-left-title-product" src={ArrowBackList} />
                    {header.backTitle}
                </a>
            ) : null}
        </div>
    );
};

export const MainForm = (props) => {
    return (
        <div className="body-inputs-page">
            <FormTypeSelectionInput
                form={props.form}
                activeTab={props.activeTab}
                setActiveTab={props.setActiveTab}
            />
            {props.form.tabs.map((tab) => {
                if (tab.key === props.activeTab) {
                    return (
                        <>
                            <RenderForm form={tab.form} />
                            {tab.form.tabs ? <RenderTabs tabs={tab.form.tabs} /> : null}
                        </>
                    );
                }
            })}
        </div>
    );
};

const RenderForm = (props) => {
    const { form } = props;
    return (
        <div className="content-inputs-page row">
            {form.main.imagePicker.active ? <RenderInput input={form.main.imagePicker} /> : null}
            <div className={form.main.wrapperClass}>
                <div className="row">
                    {form.main.initialInputs ? RenderFormInputs(form.main.initialInputs) : null}
                    {form.main.accountingCode ? <RenderInput input={form.main.accountingCode} /> : null}
                    {form.main.status ? <RenderInput input={form.main.status} /> : null}
                    {form.main.radioInput ? <RenderInput input={form.main.radioInput} /> : null}
                    <div className="col-lg-12 col-md-12 col-sm-12 style-class-box-inputs">
                        <div className="row">{RenderFormInputs(form.main)}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const RenderTabs = (props) => {
    const { tabs } = props;
    const [activeTab, setActiveTab] = useState(null);
    useEffect(() => {
        if (activeTab === null) {
            setActiveTab(tabs[0].key);
        }
    }, []);

    return (
        <div className="tabs-content-page row">
            <div className="header-tabs-content-page">
                {tabs.map((item) => {
                    return (
                        <div
                            className={activeTab === item.key ? "active-item-header-tabs-page" : "item-header-tabs-page"}
                            onClick={() => setActiveTab(item.key)}
                            key={item.key}
                        >
                            {item.name}
                        </div>
                    );
                })}
            </div>
            <div className="body-tabs-content-page">
                {tabs.map((tab, index) => {
                    // if (tab.key === activeTab) {
                    return <div key={index} className={`row ${tab.key === activeTab ? 'd-flex' : 'd-none'}`}>{RenderFormInputs(tab)}</div>;
                    // }
                })}
            </div>
        </div>
    );
};

export const FormSummary = ({ summaryInfo, submit, isEdit }) => {
    const dispatch = useDispatch();
    const sendingRequest = useSelector((state) => state).appReducer.sendingRequest;
    const formData = useSelector((state) => state).formReducer.forms;
    const editItem = useSelector((state) => state.formReducer.editItem);
    const activeIndex = useSelector((state) => state).formReducer.activeIndex;
    const deleteList = useSelector((state) => state).formReducer.deleteQueue;

    const addNewForm = () => {
        if (editItem) {
            dispatch(apiSetAlert(Messages.cannotAddFormOnEdit, "warning"));
        } else if (formData.length < 10) {
            dispatch(addForm());
        } else {
            dispatch(apiSetAlert(Messages.maxFormsReached, "warning"));
        }
    };

    const deleteForm = (index) => {
        if (formData.length > 1) {
            dispatch(setAction("delete"));
            dispatch(setDeleteQueue(index));
            setTimeout(() => {
                dispatch(deleteIndex(index));
            }, 5000);
        } else {
            dispatch(apiSetAlert(Messages.deleteFormLimit, "warning"));
        }
    };

    const undoDeleteForm = (index) => {
        dispatch(undoDeleteQueue(index));
    };

    const renderCard = (form) => {
        if (form.index === activeIndex && !sendingRequest) {
            return activeCard(form);
        } else if (deleteList && deleteList.includes(form.index)) {
            return deletingCard(form);
        } else {
            switch (form.status) {
                case "saved":
                    return savedCard(form);
                case "saving":
                    return savingCard(form);
                case "error":
                    return errorCard(form);
                case "deleting":
                    return deletingCard(form);
                default:
                    break;
            }
        }
        return closedCard(form);
    };

    const activeCard = (form) => (
        <div className="body-desc-receipt-item animation mt-2">
            <div
                className="box-icon-red-close"
                onClick={() => {
                    deleteForm(form.index);
                }}
            >
                <div className="display-accounting-code">
                    {form.main.accountingCodeType ? "اتوماتیک" : form.main.accountingCode ?? "اتوماتیک"}
                </div>
                <div className="cursor-pointer">
                    <img className="icon-red-close" src={IconDelete} alt="IconDelete" />
                </div>
            </div>
            <div className="img-part-box-receipt">
                <div className="img-box-part">
                    <div className="flex items-center justify-center">
                        <img
                            src={form.others.file_url ? form.others.file_url : summaryInfo.defaultImage}
                            alt="ImgLogoPerson"

                        />
                    </div>
                </div>
                <div className="name-product-part">
                    {form.main[summaryInfo.primaryTitleKey] && form.main[summaryInfo.primaryTitleKey].length > 0
                        ? form.main[summaryInfo.primaryTitleKey]
                        : "بدون نام نمایشی"}
                </div>
                <div className="action-box-part">
                    <div className="category">{form.others?.formTypeTitle ?? ""}</div>
                </div>
            </div>
        </div>
    );

    const summaryHeader = () => (
        <div className="title-receipt">
            <div>
                لیست پیش نویس<span>({formData.length})</span>
            </div>
            <div className="form-reset" onClick={() => dispatch(resetForm(formData[0]?.others?.formType))}>
                بازنشانی فرم
            </div>
        </div>
    );

    const closedCard = (form) => (
        <div className="close-body-desc-receipt mt-2 animation">
            <div className="body-close-desc-receipt">
                <div className="wrap-logo-title-desc">
                    <div className="logo-receipt-close">
                        <img
                            src={form.others.file_url ? form.others.file_url : summaryInfo.defaultImage}
                            alt="IconLogoPerson"

                        />
                    </div>
                    <div className="title-desc-receipt">
                        <div>{form.main[summaryInfo.primaryTitleKey] ?? "بدون نام نمایشی"}</div>
                        <div>{form.others?.formTypeTitle ?? ""}</div>
                    </div>
                </div>
                <div className="edit-remove-receipt">
                    {deleteList && deleteList.includes(form.index) ? (
                        <div className="wrapper-cancel-delete" onClick={() => undoDeleteForm(form.index)}>
                            <span>لغو</span>
                            <img src={arrowLeftFactorBlue} alt="arrowLeftFactorBlue" />
                        </div>
                    ) : (
                        <>
                            <img
                                onClick={() => {
                                    deleteForm(form.index);
                                }}
                                className="icon-red-close-hover"
                                src={IconDelete}
                                alt="IconDeleteHover"
                            />
                            <img
                                className="img-pen-hover"
                                src={IconEditHover}
                                alt="IconEditHover"
                                onClick={() => {
                                    dispatch(setIndex(form.index));
                                }}
                            />
                        </>
                    )}
                </div>
            </div>
        </div>
    );

    const savingCard = (form) => (
        <div className="close-body-desc-receipt mt-2 animation">
            <div className="body-close-desc-receipt">
                <div>
                    <div className="close-body-desc-receipt-saving"></div>
                    <div className="wrap-logo-title-desc">
                        <div className="logo-receipt-close">
                            <img
                                src={form.others.file_url ? form.others.file_url : summaryInfo.defaultImage}
                                alt="IconLogoPerson"

                            />
                        </div>
                        <div className="title-desc-receipt">
                            <div>{form.main[summaryInfo.primaryTitleKey] ?? "بدون نام نمایشی"}</div>
                            <div>{form.others?.formTypeTitle ?? ""}</div>
                        </div>
                    </div>
                </div>
                <div className="edit-remove-receipt">
                    <div className="wrapper-cancel-delete">
                        <small>در حال ذخیره سازی...</small>
                    </div>
                </div>
            </div>
        </div>
    );

    const savedCard = (form) => (
        <div className="close-body-desc-receipt-saved-box mt-2 animation">
            <div className="body-close-desc-receipt">
                <div>
                    <div className="close-body-desc-receipt-saved"></div>
                    <div className="wrap-logo-title-desc">
                        <div className="logo-receipt-close-delete">
                            <img src={form.others.file_url ? form.others.file_url : IconSaved} alt="IconLogoPerson" />
                        </div>
                        <div className="title-desc-receipt">
                            <div>{form.main[summaryInfo.primaryTitleKey] ?? "بدون نام نمایشی"}</div>
                            <div>{form.others?.formTypeTitle ?? ""}</div>
                        </div>
                    </div>
                </div>
                <div className="edit-remove-receipt">
                    {deleteList && deleteList.includes(form.index) ? (
                        <div className="wrapper-cancel-delete" onClick={() => undoDeleteForm(form.index)}>
                            <span>لغو</span>
                            <img src={arrowLeftFactorBlue} alt="arrowLeftFactorBlue" />
                        </div>
                    ) : (
                        <>
                            <img
                                onClick={() => {
                                    deleteForm(form.index);
                                }}
                                className="icon-red-close-hover"
                                src={IconDelete}
                                alt="IconDeleteHover"
                            />
                            <img
                                className="img-pen-hover"
                                src={IconEditHover}
                                alt="IconEditHover"
                                onClick={() => {
                                    dispatch(setIndex(form.index));
                                }}
                            />
                        </>
                    )}
                </div>
            </div>
        </div>
    );

    const errorCard = (form) => (
        <div className="close-body-desc-receipt mt-2 animation">
            <div className="body-close-desc-receipt">
                <div>
                    <div className="close-body-desc-receipt-error"></div>
                    <div className="wrap-logo-title-desc">
                        <div
                            className="logo-receipt-close-delete"
                            onClick={() => {
                                dispatch(apiSetAlert(form.errors, "error"));
                            }}
                        >
                            <img
                                src={form.others.file_url ? form.others.file_url : deleteWarningItem}
                                alt="IconLogoPerson"
                            />
                        </div>
                        <div className="title-desc-receipt">
                            <div>{form.main[summaryInfo.primaryTitleKey] ?? "بدون نام منایشی"}</div>
                            <div>{form.others?.formTypeTitle ?? ""}</div>
                        </div>
                    </div>
                </div>
                <div className="edit-remove-receipt">
                    {deleteList && deleteList.includes(form.index) ? (
                        <div className="wrapper-cancel-delete" onClick={() => undoDeleteForm(form.index)}>
                            <span>لغو</span>
                            <img src={arrowLeftFactorBlue} alt="arrowLeftFactorBlue" />
                        </div>
                    ) : (
                        <>
                            <img
                                onClick={() => {
                                    deleteForm(form.index);
                                }}
                                className="icon-red-close-hover"
                                src={IconDelete}
                                alt="IconDeleteHover"
                            />
                            <img
                                className="img-pen-hover"
                                src={IconEditHover}
                                alt="IconEditHover"
                                onClick={() => {
                                    dispatch(apiSetAlert(form.errors, "error"));
                                    dispatch(setIndex(form.index));
                                }}
                            />
                        </>
                    )}
                </div>
            </div>
        </div>
    );

    const deletingCard = (form) => (
        <div className="close-body-desc-receipt mt-2 animation">
            <div className="body-close-desc-receipt">
                <div>
                    <div className="wrap-close-body-desc-receipt-delete">
                        <div className="background-close-body-desc-receipt-delete">
                            <div className="close-body-desc-receipt-delete" />
                        </div>
                    </div>
                    <div className="wrap-logo-title-desc">
                        <div className="logo-receipt-close">
                            <img
                                src={form.others.file_url ? form.others.file_url : summaryInfo.defaultImage}
                                alt="IconLogoPerson"

                            />
                        </div>
                        <div className="title-desc-receipt">
                            <div>{form.main[summaryInfo.primaryTitleKey] ?? "بدون نام نمایشی"}</div>
                            <div>{form.others?.formTypeTitle ?? ""}</div>
                        </div>
                    </div>
                </div>
                <div className="edit-remove-receipt">
                    {deleteList && deleteList.includes(form.index) ? (
                        <div className="wrapper-cancel-delete" onClick={() => undoDeleteForm(form.index)}>
                            <span>لغو</span>
                            <img src={arrowLeftFactorBlue} alt="arrowLeftFactorBlue" />
                        </div>
                    ) : (
                        <>
                            <img
                                onClick={() => {
                                    deleteForm(form.index);
                                }}
                                className="icon-red-close-hover"
                                src={IconDelete}
                                alt="IconDeleteHover"
                            />
                            <img
                                className="img-pen-hover"
                                src={IconEditHover}
                                alt="IconEditHover"
                                onClick={() => {
                                    dispatch(setIndex(form.index));
                                }}
                            />
                        </>
                    )}
                </div>
            </div>
        </div>
    );

    const summaryFooter = () => (
        <div className="warp-btns-page-product-service">
            <div className="add-new-list" onClick={() => addNewForm()}>
                <img src={AddNewListIcon} alt="AddNewListIcon" />
                {summaryInfo.addTempTitle}
            </div>
            <button type="button" className="btn save-product-service" onClick={submit} disabled={sendingRequest}>
                {sendingRequest ? (
                    <img src={iconLoading} alt="loading" />
                ) : (
                    <>
                        {/* <img src={IconBookMark} alt="IconBookMark" /> */}
                        {isEdit && summaryInfo.editTitle ? summaryInfo.editTitle : summaryInfo.saveTitle}
                    </>
                )}
            </button>
        </div>
    );

    return (
        <div className="receipt-box">
            <div className="wrap-receipt-box-new">
                <div className="body-receipt-box">
                    {summaryHeader()}
                    <div className="wrap-scroll-item-form-summary">
                        <PerfectScrollbar>{formData.map((form) => renderCard(form))}</PerfectScrollbar>
                    </div>
                    {summaryFooter()}
                </div>
            </div>
        </div>
    );
};
